export enum ClientProfileTabs {
  Summary = 'SUMMARY',
  Assets = 'ASSETS',
  Disposition = 'DISPOSITION',
  Transfers = 'TRANSFERS',
}
